import {
  Box,
  Heading,
  Flex,
  Text,
  Button,
  Image,
  Stack,
} from '@chakra-ui/react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from 'src/contexts/AuthContext'
import { routes } from 'src/lib/routes'
import { useHotkeys } from 'react-hotkeys-hook'
import hotkeys from 'src/lib/hotkeys'

const MenuItems = ({ to, children }) => (
  <Text as={Link} to={to} mt={{ base: 4, md: 0 }} mr={6} display="block" style={{ textDecoration: 'none' }}>
    {children}
  </Text>
)

const Header = (props) => {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  useHotkeys(
    hotkeys.search,
    (e) => {
      e.preventDefault()
      navigate(routes.search())
    },
    {
      enableOnTags: ['INPUT'],
    }
  )
  useHotkeys(
    hotkeys.escape,
    () => {
      navigate(routes.home())
    },
    {
      enableOnTags: ['INPUT'],
    }
  )

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding="0.6rem"
      bg="#4b848a"
      color="white"
      {...props}
    >
      <Flex align="center" mr={5}>
        <Heading as="h1" size="lg" fontWeight={300}>
          {isAuthenticated
            ? `${process.env.SUPER_ENV || 'Beehively'} Super`
            : ''}
        </Heading>
      </Flex>

      {isAuthenticated ? (
        <Flex
          width={{ sm: 'full', md: 'auto' }}
          alignItems="center"
          flexGrow={1}
        >
          <MenuItems to={routes.home()}>Home</MenuItems>
          <MenuItems to={routes.search()}>Search</MenuItems>
          <MenuItems to={routes.log()}>Log</MenuItems>
          <MenuItems to={routes.admin()}>Admin</MenuItems>
          <MenuItems to={routes.settings()}>Settings</MenuItems>
          {/* <MenuItems to={routes.stats()}>Page Stats</MenuItems> */}
        </Flex>
      ) : null}

      <Box mt={{ base: 4, md: 0 }}>
        <LoginButton />
      </Box>
    </Flex>
  )
}

const LoginButton = () => {
  const { loading, isAuthenticated, logIn, logOut, currentUser } = useAuth()
  if (loading) {
    return (
      <Button bg="transparent" border="1px">
        Checking...
      </Button>
    )
  }

  if (isAuthenticated) {
    return (
      <Stack direction="row" spacing="5" isInline>
        <Image
          rounded="full"
          w="45px"
          h="45px"
          src={currentUser.picture}
          alt={currentUser.name}
        />
        <Button
          bg="transparent"
          border="1px"
          onClick={() => {
            logOut({ returnTo: window.location.origin })
          }}
        >
          Log out
        </Button>
      </Stack>
    )
  }

  return (
    <Button
      bg="transparent"
      border="1px"
      onClick={() => {
        logIn()
      }}
    >
      Login
    </Button>
  )
}

export default Header
